import { __assign } from "tslib";
import React from 'react';
import { createGiphyPlugin as originalCreateGiphyPlugin } from 'wix-rich-content-plugin-giphy';
import ToolbarIconTooltip from '../../components/ToolbarIconTooltip';
import s from './styles/toolbar-styles.scss';
// Wrapper over the original plugin constructor so we can replace the plugin's own tooltips with our own.
export function createGiphyPlugin() {
    return function (config) {
        if (config === void 0) { config = {}; }
        var plugin = __assign({}, originalCreateGiphyPlugin(config));
        var InsertButton = plugin.InsertPluginButtons[0];
        if (InsertButton) {
            var Icon_1 = InsertButton.buttonSettings.Icon;
            InsertButton.buttonSettings.tooltipText = undefined;
            InsertButton.buttonSettings.Icon = function () { return (React.createElement(ToolbarIconTooltip, { tooltipTextKey: 'editorToolbar.tooltips.addGif', className: s['tooltip-wrapper'] },
                React.createElement(Icon_1, null))); };
        }
        return plugin;
    };
}
//# sourceMappingURL=createGiphyPlugin.js.map